import React from 'react';

const ContactSection = () => {
    return (

        <>


            <section className="inner-banner-wrap">
                <div
                    className="inner-baner-container"
                    style={{ backgroundImage: 'url(/images/inner-banner.jpg)' }}
                >
                    <div className="container">
                        <div className="inner-banner-content">
                            <h1 className="inner-title">Contacts</h1>
                        </div>
                    </div>
                </div>
                <div className="inner-shape"></div>
            </section>



            <div className="contact-page-section">
                <div className="contact-form-inner">
                    <div className="container">
                        <div className="row">
                            {/* Contact Form */}
                            <div className="col-md-12">
                                <div className="contact-from-wrap">
                                    <div className="section-heading">
                                        <h5 className="dash-style">GET IN TOUCH</h5>
                                        <h2>CONTACT US TO GET MORE INFO</h2>
                                        
                                    </div>
                                 
                                </div>
                            </div>

                            {/* Contact Info */}
                            <div className="row">
                                <div className="contact-detail-wrap">
                                    
                                    <div className="details-list ">
                                        <ul>
                                            <div className='row '>

                                                <div className='col-12 col-md-4 borderr p-3'>

                                                    <li>
                                                        <span className="icon">
                                                            <i className="fas fa-phone-volume"></i>
                                                        </span>
                                                        <div className="details-content">
                                                            <h4>Phone Number</h4>
                                                            <span>+91 9284304420 <br/> +91 8308844163</span>
                                                        </div>
                                                    </li>

                                                </div>
                                                <div className='col-12 col-md-4 borderr p-3'>

                                                    <li>
                                                        <span className="icon">
                                                            <i className="fas fa-envelope-open-text"></i>
                                                        </span>
                                                        <div className="details-content">
                                                            <h4>Email Address</h4>
                                                            <span>
                                                                <a href="mailto:booking@princecab.com">booking@princecab.com</a>
                                                            </span>
                                                        </div>
                                                    </li>

                                                </div>




                                                <div className='col-12 col-md-4 borderr p-3'>
                                                    <li>
                                                        <span className="icon">
                                                            <i className="fas fa-map-signs"></i>
                                                        </span>
                                                        <div className="details-content">
                                                            <h4>Location Address</h4>
                                                            <h6>Prince Cabs</h6>
                                                            <span>  Office No 106 2nd Floor, Nilgiri Nest Co-op Housing Society, Pimple Gurav Pune, Pune, Pin -411027
</span>
                                                        </div>
                                                    </li>

                                                </div>


                                            </div>
                                        </ul>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Google Map */}
                <div className="map-section">


                    <iframe src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3156.105050387246!2d73.81402779999999!3d18.600277799999997!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMTjCsDM2JzAxLjAiTiA3M8KwNDgnNTAuNSJF!5e1!3m2!1sen!2sin!4v1757322243695!5m2!1sen!2sin" width="auto" height="450" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>

            
                </div>
            </div>
        </>
    );
};

export default ContactSection;
